
      // ローディング画面を一定時間後に非表示
      setTimeout(() => {
        const loadingScreen = document.getElementById('loading-screen');
        if (loadingScreen) {
          loadingScreen.style.opacity = '0';
          loadingScreen.style.transition = 'opacity 0.5s ease';
          setTimeout(() => {
            loadingScreen.style.display = 'none';
          }, 500);
        }
      }, 2000);
    